import { SessionObject } from '../interfaces/session';

type IdNamePair = { id: string; name: string };
export type CustomAudience = IdNamePair & {
  subtype: string;
  deliveryStatus: { code: number };
  operationStatus: { code: number };
};

type Currencies = typeof CURRENCY_OFFSETS;

type AdAccountModel = {
  name: string;
  id: string;
  userId: number;
  user?: Partial<SessionObject>;
  differentUser?: boolean;
  selected?: boolean;
  remoteId?: string;
  currency?: keyof Currencies;
  customAudiences?: CustomAudience[];
  bcts?: IdNamePair[];
};

export const CURRENCY_OFFSETS = {
  AED: 100,
  ARS: 100,
  AUD: 100,
  BDT: 100,
  BOB: 100,
  BRL: 100,
  CAD: 100,
  CHF: 100,
  CLP: 1,
  CNY: 100,
  COP: 1,
  CRC: 1,
  CZK: 100,
  DKK: 100,
  DZD: 100,
  EGP: 100,
  EUR: 100,
  GBP: 100,
  GTQ: 100,
  HKD: 100,
  HNL: 100,
  HUF: 1,
  IDR: 1,
  ILS: 100,
  INR: 100,
  ISK: 1,
  JPY: 1,
  KES: 100,
  KRW: 1,
  MOP: 100,
  MXN: 100,
  MYR: 100,
  NGN: 100,
  NIO: 100,
  NOK: 100,
  NZD: 100,
  PEN: 100,
  PHP: 100,
  PKR: 100,
  PLN: 100,
  PYG: 1,
  QAR: 100,
  RON: 100,
  RUB: 100,
  SAR: 100,
  SEK: 100,
  SGD: 100,
  THB: 100,
  TRY: 100,
  TWD: 1,
  USD: 100,
  UYU: 100,
  VEF: 100,
  VND: 1,
  ZAR: 100,
};

export const emptyAccountPlaceholder: AdAccountModel = {
  id: 'none',
  name: 'none',
  userId: -999,
};

export default AdAccountModel;
